<template>
  <div class="OnePictureInput">
    <div class="OnePictureInput__wrapper" :class="{small}" v-if="hasPicture">
      <div
        class="delete is-small is-danger OnePictureInput__delete"
        @click="update({ id: null })"
      ></div>
      <api-picture :pictureId="item" :small="small" @load="takePictureInfo"></api-picture>
      <div v-if="pictureInfo" class="ApiPicture__dl" style="display:block;z-index:9;position:absolute;bottom:-4px;right: 0;">
        <button class="button is-small"><a :href="`${pictureInfo.public_path}?api_token=${token}`" target="_blank" :download="pictureInfo.filename">&darr;</a></button>
      </div>
    </div>
    <div v-else>
      <file-upload-input
        :label="label"
        :sublabel="sublabel"
        @file="handlePicture"
      />
    </div>
  </div>
</template>

<script>
import FileUploadInput from "./UploadInput";
import ApiPicture from "./ApiPicture";

export default {
  name: "PictureInput",
  data() {
    return {
      pictureInfo: null
    };
  },
  props: {
    item: {},
    label: {
      type: String,
      required: false,
      default: ".png, noir sur transparent"
    },
    small: {
      type: Boolean,
      default: false,
    },
    sublabel: {
      type: String,
      required: false,
      default: "600px * 600px"
    }
  },
  components: {
    FileUploadInput,
    ApiPicture
  },
  computed: {
    hasPicture() {
      return !!this.item;
    },
    token() {
      return this.$store.state.user.token;
    }
  },
  methods: {
    
    update(item) {
      this.$emit("update", item);
    },
    takePictureInfo(apiPicture) {
      this.pictureInfo = apiPicture;
      this.$emit("gotpic", apiPicture);
    },
    handlePicture(pic) {
      this.update(pic);
    }
  }
};
</script>

<style lang="scss">
.OnePictureInput {
  &__wrapper {
    position: relative;
    max-width: 120px;
    &.small {
      max-width: 80px;
    }
  }
  &__delete {
    position: absolute;
    top: -8px;
    right: -8px;
    z-index: 2;
  }
}
</style>
